import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { Variant, Option, Product, Metafield } from 'src/app/shop';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-variant-swatch-list',
  templateUrl: './variant-swatch-list.component.html',
  styleUrls: ['./variant-swatch-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FromDictionaryPipe],
})
export class VariantSwatchListComponent {
  @Input() option!: Option;
  @Input() product!: Product;
  @Input() selectedOptionsFromParams: Params | undefined;

  hoverLabel?: string;

  getSelectedOptionValue(optionName: string) {
    return this.selectedOptionsFromParams?.[optionName];
  }

  isAvailable(key: string, value: string) {
    return this.product.variants?.some(
      variant => variant.selectedOptions?.some(option => option.name === key && option.value === value) && variant.availableForSale
    );
  }

  getOptionAsQueryParam(option: Option, value: string) {
    return { [option.name]: value };
  }

  // klein foutje tijdens product import van Thomas, bugfix om vergeten veld Title te hernoemen...
  variantLabel(label: string) {
    if (label === 'Title') {
      return 'variant';
    }
    return label;
  }

  getSwatch(variantName: string) {
    const possibleVariants = this.product.variants.filter(
      v => v.selectedOptions.find(o => o.name === this.option.name)?.value === variantName
    );

    // From possibleVariants, get metafield with key 'kleurcode'
    const hex = possibleVariants.map(v => v.metafields?.find(m => m?.key === 'kleurcode')?.value).filter(v => v);
    const imageUrl = possibleVariants
      .map(v => v.metafields?.find(m => m?.key === 'kleur_afbeelding')?.reference?.image?.url)
      .filter(v => v);

    return {
      color: hex?.[0],
      image: imageUrl?.[0] ? `url('${imageUrl[0]}')` : undefined,
    };
  }
}
